/**
 * Available traffic light values
 */
export type MosaicTrafficLightsValue =
  | "none"
  | "FromScratch"
  | "FromBasicLayout"
  | "FromTemplate"
  | "RedError"
  | "AmberChangeExpected"
  | "GreenOk"
  | "BlankNotEvaluated"
  | "ChangedUnknown"
  | "GreenOverride";

/**
 * Check whether a value is a valid `MosaicTrafficLightsValue`.
 *
 * @param obj - The value to test (usually a string).
 * @returns True when `obj` is one of the allowed traffic-light literal values.
 */
export const isMosaicTrafficLightsValue = (obj: unknown): obj is MosaicTrafficLightsValue =>
  typeof obj === "string" &&
  [
    "none",
    "FromScratch",
    "FromBasicLayout",
    "FromTemplate",
    "RedError",
    "AmberChangeExpected",
    "GreenOk",
    "BlankNotEvaluated",
    "ChangedUnknown",
    "GreenOverride",
  ].includes(obj as string);
